import { OfferKindEnum } from '../../../../services/exports/Constants';

const offers: Record<OfferKindEnum & { from_to: string }, any> = {
  [OfferKindEnum.PercentageOffByProducts]: {
    title: '{{percentageAmount}}% korting op geselecteerde items',
    description:
      'Bespaar {{percentageAmount}}% op je bestelling bij geselecteerde items. De aanbieding is geldig{{fromTo}} totdat het maximale promotieplafond is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
  },
  [OfferKindEnum.PercentageOffByMinSpendValue]: {
    title: '{{percentageAmount}}% korting vanaf {{minSpendValue}}',
    description:
      'Bespaar {{percentageAmount}}% op je bestelling. De aanbieding is geldig{{fromTo}} totdat het maximale promotieplafond is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
  },
  [OfferKindEnum.AmountOffByProducts]: {
    title: 'Bespaar {{amount}} op geselecteerde items',
    description:
      'Bespaar {{amount}} bij geselecteerde items. De aanbieding is geldig{{fromTo}} totdat het maximale promotieplafond is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
  },
  [OfferKindEnum.AmountOffByMinSpendValue]: {
    title: 'Bespaar {{amount}} vanaf {{minSpendValue}}',
    description:
      'Bespaar {{amount}} bij een bepaalde bestelwaarde. De aanbieding is geldig{{fromTo}} totdat het maximale promotieplafond is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
  },
  [OfferKindEnum.Bogo]: {
    title: 'Koop 2, betaal 1!',
    description:
      'Koop één item en krijg het tweede gratis. De aanbieding is geldig{{fromTo}} totdat de promotielimiet is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
  },
  [OfferKindEnum.BogoHalfPrice]: {
    title: 'Tweede item voor halve prijs!',
    description:
      'Koop één item en krijg het tweede voor de helft van de prijs. De aanbieding is geldig{{fromTo}} totdat de promotielimiet is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
  },
  [OfferKindEnum.FreeItemByMinSpendValue]: {
    title: 'Gratis item bij bestelwaarde',
    description:
      'Ontvang een gratis item als je aan de actievoorwaarden voldoet. De aanbieding is geldig{{fromTo}} totdat de promotielimiet is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
    reward_items_description: 'Kies je gratis item.',
  },
  [OfferKindEnum.FreeItemByProducts]: {
    title: 'Gratis item bij je bestelling',
    description:
      'Ontvang een gratis item als je aan de actievoorwaarden voldoet. De aanbieding is geldig{{fromTo}} totdat de promotielimiet is bereikt, afhankelijk van wat het eerst komt. Niet combineerbaar met andere acties.',
    qualifying_items_description: 'Selecteer de items die de klant moet bestellen om het gratis item te ontvangen.',
    reward_items_description: 'Kies je gratis item.',
  },
};

export default {
  offers,
  from_to: ' van {{startsAt}} tot {{endsAt}} of',
  qualifying_items_title: 'Kwalificerende items',
  reward_items_title: 'Gratis items',
  buttons: {
    add: 'Toevoegen aan winkelwagen',
  },
};
